import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ClientConfigInterceptor implements HttpInterceptor {
  private readonly credentialUrls = [
    '/api/CAS/login',
    '/api/CAS/tokenRefresh',
    '/api/CAS/signout',
    '/api/Authorization/RefreshToken',
    '/api/identity/refresh-token',
    '/api/identity/validate-token'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const configuredRequest = req.clone({
      withCredentials: this.shouldSendCredentials(req.url),
      setHeaders: {
        'X-Client-Code': 'CRM'
      }
    });

    return next.handle(configuredRequest);
  }

  private shouldSendCredentials(url: string): boolean {
    const normalizedUrl = url.toLowerCase();
    return this.credentialUrls.some(path => normalizedUrl.includes(path.toLowerCase()));
  }
}
